import request from '@/services/api'
async function updateChild(childId: number, postData: any) {
  const path = `/children/${childId}`

  try {
    const response = await request(path, {
      method: 'PUT',
      headers: {
        'Application-Version': '2.15.0',
        Platform: 'web',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

async function createChild(postData: any) {
  const path = `/children`

  try {
    const response = await request(path, {
      method: 'POST',
      headers: {
        'Application-Version': '2.15.0',
        Platform: 'web',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(postData)
    })

    const data = await response.json()
    // console.log('Success:', data)
    return data
  } catch (error) {
    console.error('Error:', error)
    throw error
  }
}

export default { updateChild, createChild }
